import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-pincweb',
  templateUrl: './pincweb.component.html',
  styleUrls: ['./pincweb.component.css']
})
export class PincWebComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}

